import * as React from "react";
import {ConfigProvider} from "antd";
import styled, {ThemeProvider} from "styled-components";
import {antDesignTheme, styledComponentTheme} from "./shared/theme";

const Wrapper = styled.section`
    width: 100%;
`;

const ProvidersWrapper = ({children}) => (
        <ThemeProvider theme={styledComponentTheme}>
            <ConfigProvider theme={antDesignTheme}>
                <Wrapper>
                    {children}
                </Wrapper>
            </ConfigProvider>
        </ThemeProvider>
    );

export default ProvidersWrapper;
